const inputChipSizeVariants = {
    '2xs': {
        containerSlot: 'p-0 pl-[6px] pr-1 rounded-md h-5 pr-1',
        labelTextSlot: 'text-body3 py-0 pl-[2px]',
        iconLeftSlot: 'py-0 scale-80 mr-1',
        iconRightSlot: 'py-0 scale-80 -mx-[2px] ml-1'
    },
    xs: {
        containerSlot: 'py-[2px] pl-2 h-6 pr-1',
        labelTextSlot: 'py-0',
        iconLeftSlot: 'py-0 ml-0 scale-90',
        iconRightSlot: 'py-0 mx-0 scale-90 ml-1'
    },
    sm: {
        containerSlot: 'py-[2px] pl-2 h-6 pr-1 h-8',
        labelTextSlot: 'py-0',
        iconLeftSlot: 'py-0 ml-0 scale-90 mr-1',
        iconRightSlot: 'py-0 mx-0 scale-90 ml-2 mr-1'
    }
};
const InputChipSizes = Object.keys(inputChipSizeVariants);
const inputChipSlots = {
    containerSlot: 'focus-visible:ring-2 focus-visible:ring-primary-8 flex items-center border border-solid py-[1px] rounded-action-sm focus-visible:outline-none focus-visible:ring-offset-2 hover:cursor-pointer hover:aria-pressed:cursor-pointer transition-all duration-150 ease-in-out  w-fit max-h-8 ',
    iconLeftSlot: '',
    iconRightSlot: 'py-0 px-0',
    labelTextSlot: 'whitespace-nowrap text-body2 py-0 pr-0 pl-1',
    checkboxSlot: 'appearance-none opacity-0 absolute w-1 h-1'
};
const inputChipDefaultVariants = {
    emphasis: 'regular',
    type: 'chip'
};
export { InputChipSizes, inputChipDefaultVariants, inputChipSizeVariants, inputChipSlots };
